import { Routes } from '@angular/router';
import { ForbiddenError, NotFound, ServerError } from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { AutenticacaoComponent } from './components/autenticacao/autenticacao-component';
import { SucessoAutenticacaoComponent } from './pages/sucesso-autenticacao/sucesso-autenticacao.component';
import { captchaAuthGuard } from './guards/captcha-guard';

export const routes: Routes = [
   {
       path: '',
       component: AutenticacaoComponent,
       pathMatch: 'full'
   },
  {
       path: 'login',
       component: AutenticacaoComponent,
       canActivate: [captchaAuthGuard]
   },
   {
       path: 'sucesso-autenticacao',
       component: SucessoAutenticacaoComponent
   },
   {
       path: 'nao-encontrado',
       loadComponent: () => NotFound,
       pathMatch: 'full',
   },
   {
       path: 'erro-servidor',
       loadComponent: () => ServerError,
       pathMatch: 'full',
   },
   {
       path: 'proibido',
       loadComponent: () => ForbiddenError,
       pathMatch: 'full',
   },
   {
       path: '**',
       redirectTo: 'nao-encontrado',
   },
];